import { MuiThemeProvider, StylesProvider } from "@material-ui/core/styles";
import { ThemeProviderProps } from "@material-ui/styles/ThemeProvider";
import * as React from "react";
import { ThemeProvider } from "styled-components";

export const RelodeThemeProvider = <T extends object>(
    props: ThemeProviderProps<T>
) => {
    return (
        <ThemeProvider theme={props.theme}>
            <MuiThemeProvider theme={props.theme}>
                <StylesProvider injectFirst>{props.children}</StylesProvider>
            </MuiThemeProvider>
        </ThemeProvider>
    );
};
